import React from 'react'
import { UserGroupIcon, ArrowRightIcon } from '@heroicons/react/24/outline'

const PriorityBookingMembershipRequired = ({ eventName }) => {
  return (
    <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-6">
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0">
          <UserGroupIcon className="w-6 h-6 text-amber-600 dark:text-amber-400" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-medium text-amber-900 dark:text-amber-100 mb-2">
            Membership Required for Priority Booking
          </h3>
          <p className="text-amber-700 dark:text-amber-300 mb-4">
            Priority booking for this event is available to members only. Purchase a membership to get early access to tickets for future events.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="/memberships"
              className="inline-flex items-center px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white rounded-md transition-colors"
            >
              <UserGroupIcon className="w-4 h-4 mr-2" />
              View Memberships
              <ArrowRightIcon className="w-4 h-4 ml-2" />
            </a>
            <div className="text-sm text-amber-600 dark:text-amber-400 flex items-center">
              General booking opens when priority booking ends
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PriorityBookingMembershipRequired